const global = {
    body: {
        fontFamily: "'Montserrat', sans-serif;",
        background: "#111922"
    }
}
export default global;